import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {axios} from './utils/request'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.use(Element);

router.beforeEach((to, from, next) => {
    updateTitle(to.name);
    if(to.meta.requireAuth) {
        sessionStorage.setItem("backIn", to.path);
        store.dispatch( "auth/isLogin").then(() => {
            next();
        });
    } else {
        next();
    }
});

function updateTitle(title) {
    document.title = process.env.VUE_APP_NAME + "-" + title;
}

function doLogin(next) {
    location.href = "/api/wx/auth";
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
